
//Here's the api connector to communicate with the wordpress gallery endpoint:
//https://localhost/cms-service/index.php/wp-json/gallery/v1/id/45

import { get } from '@kit/utils/APIV1.js'

//https://localhost/cms-service/index.php/wp-json/v1/home/id/45?pretty
export const home = async() => {
  return get(`home/id/45`)
}